import api from "../api";

class AccountService {
	async getAllAccounts(filters) {
		return new Promise((res, reject) => {
			let params = {
				page: 0,
				size: 1000,
				users: filters && filters.users ? filters.users : [],
				q: filters && filters.q ? filters.q : "",
			};
			api
				.get("/accounts", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	// calls proc spMergeAccounts
	async mergeAccounts(params) {
		return new Promise((res, reject) => {
			return api
				.get("/accounts/mergeAccounts", params)
				.then(() => {
					res();
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async getAccountsByUser(userId) {
		return new Promise((res, reject) => {
			api
				.get("/users/" + userId + "/accounts")
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//to get all account types
	async getAllAccountTypes() {
		return new Promise((res, reject) => {
			api
				.get("/accountTypes")
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async getAccount(id) {
		return new Promise((res, reject) => {
			api
				.get("/sources/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async createAccount(account) {
		return api.post("/sources", account);
	}

	async updateAccount(account) {
		return new Promise((res, reject) => {
			api
				.put("/sources/" + account.id, account)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async getRepAnalytics(id, scope) {
		return new Promise((res, reject) => {
			return api.get('/mobileRepAnalytics/' + id, {scope: scope}).then(data => {
				res(data);
			}).catch(err => {
				reject();
			})
		})
	}

	//user id
	// calls proc spMobileStatisticsForSalesRepsMonth
	async getRepsForLocationsMonth(id, month, year) {
		let params = {
			id: id,
			month: month,
			year: year
		};

		return new Promise((res, reject) => {
			return api.get('/mobileRepsForLocationsMonth/', params).then(data => {
				res(data);
			}).catch(err => {
				reject(err);
			})
		})
	}

	//user id
	// calls proc spMobileStatisticsForLocationsMonth
	async getLocationsStatisticsMonth(id, month, year) {
		let params = {
			id: id,
			month: month,
			year: year
		};

		return new Promise((res, reject) => {
			return api.get('/mobileStatisticsForLocationsMonth/', params).then(data => {
				res(data);
			}).catch(err => {
				reject(err);
			})
		})
	}
}

const accountService = new AccountService();

export default accountService;
